import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';

class SheldonUpdKskCfg extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cfgName: '',
      cfgValue: '',
      type: '',
      path: '',
      content: '',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type, event) {
    event.preventDefault();

    let { cfgName, cfgValue } = this.state;
    let { hostInfo, onKskCfgChanged } = this.props;
    let { ip } = hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let kskapi = Util.getKskApiPath(hostInfo);

    let path = '';
    let method = 'GET';
    switch (type) {
      case 'kskcfg':
        path = `${kskapi}/ksk/cmddbcfg`;
        break;
      case 'updkskcfg':
        path = `${kskapi}/sync/updkskcfg?name=${cfgName}&value=${cfgValue}`;
        break;
      // case 'gmainspect':
      //   path = `${kskapi}/ksk/gmainspect?username=${queryParams.username}&email=${queryParams.email}`;
      //   break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    $.ajax({ url: path, dataType: 'json', method: method })
      .always((arg) => {
        this.inProgress = false;
      })
      .done((data) => {
        if (type === 'kskcfg' && data.data && data.data.kskcfg) {
          let kskcfg = {};
          data.data.kskcfg.forEach((cfg) => {
            kskcfg[cfg.name] = cfg.value;
          });
          data = kskcfg;
        }
        this.setState({
          content: <JsonView title={path} data={data} />,
        });
        onKskCfgChanged();
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { cfgName, cfgValue, type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>Update kskcfg</h2>
        <div style={{ margin: '20px 0' }}>
          For updating or adding new entry to kskcfg. Mainly used to update <b>serverurl</b> to
          point kiosk to different capsvr or transaction server.
        </div>
        <div className='sheldon-buttons'>
          <form className='pure-u-2-3 pure-form'>
            <fieldset>
              {/*
              <label style={{marginRight: 10}}>Name:</label>
*/}
              <input
                className='pure-input-1-5'
                style={{ marginRight: 5 }}
                type='text'
                placeholder='kskcfg name'
                value={cfgName}
                onChange={(event) => this.setState({ cfgName: event.target.value })}
              />
              <input
                className='pure-input-1-2'
                style={{ marginRight: 5 }}
                type='text'
                placeholder='kskcfg value'
                value={cfgValue}
                onChange={(event) => this.setState({ cfgValue: event.target.value })}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleButtonClick.bind(this, 'updkskcfg')}
              >
                Update
              </button>
            </fieldset>
          </form>
          <div className='pure-u-1-3'>
            <span style={{ paddingRight: 10 }}>View Info:</span>
            <button
              className={type === 'kskcfg' ? 'pure-button pure-button__selected' : 'pure-button'}
              onClick={this.handleButtonClick.bind(this, 'kskcfg')}
            >
              kskcfg
            </button>
          </div>
        </div>
        <div className='sheldon-content'>
          <div style={{ height: panelHeight - 280, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonUpdKskCfg;



// WEBPACK FOOTER //
// ./src/components/SheldonUpdKskCfg.js